import { css } from '@emotion/react';

export const globalStyles = css`
  :lang(ko) {
    word-break: keep-all;
  }
`;
